import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  const services = [
    {
      title: 'הלחמות מקצועיות',
      items: [
        'הלחמות רכיבי SMT/TH/FINE PITCH',
        'הלחמות BGA ברמה אזרחית וצבאית',
        'תיקוני הלחמות עדינות בעבודה תחת מיקרוסקופ',
        'הדבקת רכיבים עדינים',
        'בקרת איכות קפדנית לכל הלחמה'
      ]
    },
    {
      title: 'עבודות לייזר וחיווט',
      items: [
        'עבודה מקצועית עם סיב לייזר',
        'ריתוכי לייזר מדויקים',
        'חיווט מעגלים לפי שרטוטים',
        'הכנת כל סוגי הצמות',
        'לחיצות פינים מקצועיות'
      ]
    },
    {
      title: 'שירותי פיתוח ותיעוד',
      items: [
        'הרכבת מעגלי PROTOTYPE',
        'עבודה מול מחלקות פיתוח',
        'הכנת דגמי פיתוח',
        'תיעוד מפורט לייצור',
        'ביצוע תיקונים ושינויים במעגלי פיתוח'
      ]
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <div className="gradient-primary text-white relative overflow-hidden wave-animation">
        <div className="absolute inset-0 pattern-grid"></div>
        <div className="absolute inset-0 bg-primary-900/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center relative z-10">
            <h1 className="text-5xl font-bold mb-6 animate-fade-in">אודות D.I.Technologies</h1>
            <p className="text-xl text-primary-100 max-w-3xl mx-auto animate-fade-in" style={{animationDelay: '0.2s'}}>
              מובילים בתחום ההלחמות המקצועיות והפתרונות הטכנולוגיים המתקדמים
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* מי אנחנו */}
          <div className="mb-16 text-center">
            <h2 className="section-title">מי אנחנו</h2>
            <p className="section-description">
              D.I.Technologies מתמחה במתן פתרונות הלחמה מתקדמים ושירותים טכנולוגיים ברמה הגבוהה ביותר. 
              אנו מביאים ניסיון רב שנים בתחום ההלחמות המקצועיות, עם דגש על דיוק, איכות ושירות אישי.
            </p>
          </div>

          {/* שירותים מפורטים */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {services.map((service, index) => (
              <div key={index} className="feature-card">
                <h3 className="text-2xl font-semibold mb-6 text-primary-600">{service.title}</h3>
                <ul className="space-y-3">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <svg className="w-5 h-5 text-primary-500 mt-1 ml-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* יתרונות */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-16">
            <h2 className="text-3xl font-bold mb-8 text-center text-gray-900">היתרונות שלנו</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start">
                <div className="icon-container ml-4 flex-shrink-0">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">גמישות מקסימלית</h3>
                  <p className="text-gray-600">אנו מגיעים לבית הלקוח לפי הצורך ומציעים אפשרות לביצוע העבודה גם במעבדה שלנו</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="icon-container ml-4 flex-shrink-0">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">איכות מוכחת</h3>
                  <p className="text-gray-600">עבודה ברמה אזרחית וצבאית, עם הקפדה על הסטנדרטים הגבוהים ביותר</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="icon-container ml-4 flex-shrink-0">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">זמינות גבוהה</h3>
                  <p className="text-gray-600">מענה מהיר ומקצועי לכל צורך, כולל עבודות דחופות ופרויקטים מורכבים</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="icon-container ml-4 flex-shrink-0">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">מומחיות טכנית</h3>
                  <p className="text-gray-600">ידע נרחב בעבודה עם ציוד מתקדם וטכנולוגיות חדישות</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-6">מוכנים להתחיל?</h2>
            <p className="text-xl text-gray-600 mb-8">צרו איתנו קשר עוד היום לקבלת הצעת מחיר מותאמת אישית</p>
            <Link 
              to="/contact"
              className="hero-button bg-primary-600 text-white hover:bg-primary-700 hover-glow"
            >
              דברו איתנו
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 